import { ref } from '@vue/composition-api'

export default (defaultPageSize = 10) => {
  const currentPage = ref(1)

  const setCurrentPage = (newCurrentPage) =>
    (currentPage.value = newCurrentPage)

  const pageSize = ref(defaultPageSize)

  const setPageSize = (newPageSize) => (pageSize.value = newPageSize)

  return {
    currentPage,
    setCurrentPage,

    pageSize,
    setPageSize
  }
}
